(() => {

gsap.registerPlugin(ScrollTrigger);

function initEditorial() {

    const section = document.querySelector(".ecoma-editorial");

    if (!section) return;

    const data = JSON.parse(
        document.getElementById("editorial-data").textContent
    );

    const number = section.querySelector(".story-number");
    const title = section.querySelector(".story-title");
    const description = section.querySelector(".story-description");
    let currentIndex = -1;

   function changeStory(index){

    gsap.killTweensOf([number,title,description]);

    gsap.to(
        [number,title,description],
        {
            opacity:0,
            y:20,
            duration:.25,
            ease:"power2.out",
            onComplete(){

            number.textContent = data[index].number;
            title.textContent = data[index].title;
            description.innerHTML =
                `<p>${data[index].description}</p>`;

           

            gsap.to(
    [number,title,description],
    {
        opacity:1,
        y:0,
        duration:.5,
        ease:"power2.out"
    }
);

                }
            }
        );

    }

    number.textContent = data[0].number;
title.textContent = data[0].title;
description.innerHTML = `<p>${data[0].description}</p>`;

    ScrollTrigger.create({

        trigger:section,

        start:"top top",

        end:`+=${data.length*160}%`,

        pin:true,

       scrub:1.2,

       snap:{
    snapTo:1/(data.length-1),
    duration:{
        min:0.2,
        max:0.5
    },
    delay:0,
    ease:"power2.out"
},

 onUpdate: self => {

    let index = Math.round(
        self.progress * (data.length - 1)
    );

    if (index !== currentIndex) {
        currentIndex = index;
        changeStory(index);
    }

}

    });

}

window.addEventListener("load",initEditorial);

})();